module.exports = "<ng-container>\n    <div #walkMap class=\"maps\"></div>\n</ng-container>"